import React, { useState, useEffect } from "react";
import { Images } from "../../../assets/images";
import { Helmet } from "react-helmet";
import { Hero } from "../Resources/Webinar";
import { HyperLink } from "../../common/FormInputs";
import { CSSTransition } from "react-transition-group"; // Added for smooth animations
import {
  Container,
  HeroContent,
  HeroTitle,
  NumberList,
  List,
  ContentWrapper,
  MainSection,
  ContentBox,
  ImagePlaceholder,
  Description,
  Section,
  SectionHeader,
  SectionContent,
  ContentTitle,
  Heading,
  Paragraph,
  ArrowIcon,
  HeroOverlay,
} from "./Styles";

const MediationTrainingProgram = () => {
  const [expanded, setExpanded] = useState(null);

  const toggle = (key) => setExpanded(expanded === key ? null : key);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      key: "objectives",
      title: "Course Objectives",
      content: (
        <p>
          Mediation as a{" "}
          <HyperLink onClick={() => window.open(`https://user.iamch.org.in/`)}>
            dispute resolution
          </HyperLink>{" "}
          process involves handling interpersonal dynamics and negotiations. The
          objective of this course is to impart the necessary skills,
          techniques, and process knowledge required by anyone to resolve a
          dispute of simple to moderate complexity, independently through
          mediation.
        </p>
      ),
    },
    {
      key: "learning",
      title: "Learning Objectives",
      content: (
        <NumberList>
          <li>What is mediation and where is it used?</li>
          <li>Nature of disputes & personalities in a dispute</li>
          <li>What is the objective of mediation?</li>
          <li>Characteristics of mediation</li>
          <li>Mediation and its interplay with the court system</li>
          <li>Principles of Negotiation.</li>
          <li>Structured Process of Mediation</li>
          <li>
            How to handle impasse and how to problem solve a tough mediation
          </li>
          <li>What NOT to do in a mediation and what is NOT mediation</li>
          <li>
            Communication skills required in conducting a mediation - Observing,
            Listening, Reframing, Managing Bias
          </li>
          <li>
            Writing a mediation settlement agreement and minuting meetings
          </li>
          <li>Ethics of a mediator and how to handle conflict of interest</li>
        </NumberList>
      ),
    },
    {
      key: "duration",
      title: "Duration",
      content: (
        <List>
          <li>15 Hours of Classroom Sessions over 3 weekends.</li>
          <li>15 hours of Self Learning Videos.</li>
          <li>10 hours of Role Plays & Exercises.</li>
        </List>
      ),
    },
    {
      key: "curriculum",
      title: "Curriculum",
      content: (
        <p>
          Participants are expected to complete the self-learning modules and
          exercises prior to the classroom sessions. Role plays & exercises
          during the classroom sessions may also be followed by similar
          exercises, role plays, and discussions to be done among participants
          in groups, on their own, which will be assessed and evaluated. Video
          recordings of role plays will need to be shared by participants.
        </p>
      ),
    },
    {
      key: "pricing",
      title: "Pricing",
      content: (
        <p>
          For scheduling a program and pricing enquiries, please contact us.
          <div style={{ margin: "10px 0" }}>
            <b>Training Cost:</b> Rs. 40,000 + GST**
          </div>
          <div style={{ margin: "10px 0" }}>
            <b>Limited Time Offer:</b>** Individuals can pay Rs. 25,000 upfront
            and the remainder when they start mediating.
          </div>
        </p>
      ),
    },
    {
      key: "batches",
      title: "Batches",
      content: (
        <p>
          <b>Size of the batch*:</b>
          <List>
            <li>Min participants: 15</li>
            <li>Max participants: 21**</li>
          </List>
          <div>* Batch size is in multiples of 3 for role-play exercises.</div>
          <div>
            ** The minimum number of registrations required to commence a batch
            is 15. Registration is on a first-come, first-served basis up to 21
            participants.
          </div>
        </p>
      ),
    },
    {
      key: "eligibility",
      title: "Eligibility",
      content: <p>Graduate with professional experience.</p>,
    },
    {
      key: "contact",
      title: "Contact",
      content: (
        <p>
          For scheduling a program and pricing enquiries, please contact:
          <div style={{ margin: "10px 0" }}>
            <b>Email:</b>{" "}
            <a href="mailto:support@justact.co.in">support@justact.co.in</a>
          </div>
          <div style={{ margin: "10px 0" }}>
            <b>Mobile:</b> +91 95009 09888 | 87545 76111 | 73959 13222
          </div>
        </p>
      ),
    },
    {
      key: "faq",
      title: "Frequently Asked Questions",
      content: (
        <NumberList>
          <li>
            <Heading>What is IAMC?</Heading>
            <Paragraph style={{ marginTop: 10 }}>
              ❖ IAMC offers Online Dispute Resolution services to disrupt the
              way disputes are resolved today.
            </Paragraph>
          </li>
          <li>
            <Heading>What is the duration and curriculum?</Heading>
            <Paragraph style={{ marginTop: 10 }}>
              The 40-hour training includes:
            </Paragraph>
            <Paragraph>
              ❖ 15 Hours of Classroom Sessions over 3 weekends
            </Paragraph>
            <Paragraph>❖ 15 hours of Self Learning Videos</Paragraph>
            <Paragraph>❖ 10 hours of Role Plays & Exercises</Paragraph>
            <Paragraph>
              The training prepares attendees with concepts and practical
              learning to enable them to become mediators.
            </Paragraph>
            <Paragraph>
              Participants are expected to complete the self-learning modules
              and exercises prior to the classroom sessions. Role plays &
              exercises during the classroom sessions may also be followed by
              similar exercises, role plays, and discussions to be done among
              participants in groups, on their own, which will be assessed and
              evaluated. Video recordings of role plays will need to be shared
              by participants.
            </Paragraph>
          </li>
          <li>
            <Heading>
              Can I become a mediator with IAMC after this program?
            </Heading>
            <Paragraph style={{ marginTop: 10 }}>
              ❖ Mediation as a dispute resolution process involves handling
              interpersonal dynamics and negotiations. The objective of this
              course is to impart the necessary skills, techniques, and process
              knowledge required by anyone to independently resolve a dispute of
              simple to moderate complexity.
            </Paragraph>
            <Paragraph>
              ❖ Attendees desirous of empanelling themselves will be required to
              fill up a small form and undergo an evaluation by a panel of
              evaluators.
            </Paragraph>
          </li>
        </NumberList>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>
          Online Mediation Training Program - Dispute Resolution Program -
          IAMC
        </title>
        <meta
          name="description"
          content="Online Mediation Training Program involves handling interpersonal dynamics & negotiations to resolve a dispute of simple to moderate complexity, independently through mediation."
        />
        <meta
          name="keywords"
          content="Online Mediation Training Program, Mediation Dispute Resolution Training Programme, Mediation Training Programme, Online Mediation, Dispute Resolution Online, Online Dispute Resolution in India, JustAct"
        />
      </Helmet>

      <Container>
        <Hero bgImage={Images.longProgram}>
          <HeroOverlay>
            <HeroContent>
              <HeroTitle>Mediation Training Programme</HeroTitle>
            </HeroContent>
          </HeroOverlay>
        </Hero>

        <MainSection>
          <ContentWrapper>
            <ImagePlaceholder bgImage={Images.Mediation} />

            <ContentBox>
              <ContentTitle>Mediation Training Programme</ContentTitle>
              <Description>
                We’re so glad that you showed interest in training! This
                document is meant to provide you with the course objectives and
                the learning objectives of this training program.
              </Description>

              {sections.map(({ key, title, content }) => (
                <Section key={key}>
                  <SectionHeader onClick={() => toggle(key)}>
                    <span>{title}</span>
                    <ArrowIcon expanded={expanded === key}>
                      {expanded === key ? "▲" : "▼"}
                    </ArrowIcon>
                  </SectionHeader>

                  <CSSTransition
                    in={expanded === key}
                    timeout={250}
                    classNames="expand"
                    unmountOnExit
                  >
                    <SectionContent>{content}</SectionContent>
                  </CSSTransition>
                </Section>
              ))}
            </ContentBox>
          </ContentWrapper>
        </MainSection>
      </Container>
    </>
  );
};

export default MediationTrainingProgram;